import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box, Grid } from '@chakra-ui/react';
import { RFNodeIcon, RFSvg } from '../../base';
import { ERFElement } from '../../../enums';
import { useNodeTemplate } from '../../../hooks';
import { RFConfigContext } from '../../../contexts';
import { ABSORBER_CONFIG } from './RFAbsorberNode.config';
/**
 * Component renders "absorber" type of node of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_NODE_TYPES.
 */
const RFAbsorberNodeFC = ({ id, data, selected, isConnectable = true }) => {
    const { isInspector } = useContext(RFConfigContext) ?? {};
    const { isValidTemplate, renderPorts, renderError } = useNodeTemplate({
        id,
        selected,
        templateCode: data.templateCode,
        config: ABSORBER_CONFIG
    });
    return isValidTemplate ? (_jsxs(_Fragment, { children: [_jsxs(Grid, { "data-templateid": data.templateCode, templateRows: "auto auto", gap: "4px", children: [_jsx(RFNodeIcon, { id: id, isSelected: selected, isInspector: isInspector, rfType: ERFElement.Absorber, templateCode: data.templateCode ?? '', children: _jsx(RFSvg, { name: ABSORBER_CONFIG.icon, width: 140, height: 300 }) }), _jsx(Box, { p: "0 4px", w: "152px", textAlign: "center", fontSize: "12px", lineHeight: "14px", fontWeight: 700, className: "cut-text", children: data.title })] }), renderPorts(isConnectable, isInspector)] })) : (_jsx(_Fragment, { children: renderError() }));
};
export const RFAbsorberNode = RFAbsorberNodeFC;
//# sourceMappingURL=RFAbsorberNode.js.map